
import PageTitle from '@/UI/components/common/PageTitle.vue';
import { mixins } from 'vue-class-component';
import { ProxyDataForm } from '@/UI/components/Helpers/ProxyDataForm';
import BaseDataForm from '@/UI/components/Helpers/BaseForm/BaseDataForm.vue';
import { Component } from 'vue-property-decorator';
import { Button, Menu, List, Row, Table } from 'ant-design-vue';
// import { TasksTableMix } from '@/UI/mixins/Clients/TasksTableMix';
@Component({
    components: {
        PageTitle,
        BaseDataForm,
        'a-button': Button,
        'a-menu-item': Menu.Item,
        'a-list-item': List.Item,
        'a-list-item-meta': List.Item.Meta,
        'a-table': Table,
        'a-row': Row,
    },
})
export default class ClientTasks extends mixins(ProxyDataForm) {
    async created(): Promise<void> {
         try {
             this.formReady = true;
             this.tableLoad = true;
         } catch (err) {
             console.log('Clients task form Error');
         }
    }
}
